import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useRegrasCalculoContext } from 'pages/RegrasCalculo'
import { useParams } from 'react-router-dom'
import { regrasCalculo, updateRegrasCalculoSchema } from 'service/api'
import { toast } from 'sonner'
import FormRegraCalculo from '../forms/FormRegraCalculo'

export default function EditarRegraCalculoPage() {
    const { regrasCalculoId } = useParams()
    const { data } = useRegrasCalculoContext()
    const { mutateAsync, isLoading } = regrasCalculo.mutations.useUpdate({
        invalidateQuery: true,
        onSuccess: () => {
            toast.success('Regra de cálculo editada com sucesso')
        },
        onError: e => {
            toast.error(e.message)
        },
    })

    const row = data?.find(item => item.id === Number(regrasCalculoId))
    if (!row) return null

    return (
        <Dialog.Root
            open={hasPermission(['update', 'RegrasDeCálculo'])}
            onSubmit={values => mutateAsync({ ...values, id: row.id })}
            loading={isLoading}
            width="62rem"
            schema={updateRegrasCalculoSchema}
            defaultValues={row}
        >
            <Dialog.Title>Editar regra de cálculo</Dialog.Title>
            <Dialog.Content dividers>
                <FormRegraCalculo />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
